import { render, staticRenderFns } from "./AddProgram.vue?vue&type=template&id=c4cb74b2"
import script from "./AddProgram.vue?vue&type=script&lang=ts"
export * from "./AddProgram.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports